module.exports = __webpack_public_path__ + "img/lamp-icon.a1806409.svg";